import React from 'react'
import './HintSection.sass'
import { Hint, Topic } from '../../types/data'
import HintBubble, { HintItemType } from '../../components/ChatMessage/HintBubble'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'

interface Props {
    topic: Topic
    hints: Hint[]
    onSelect: (item: Hint) => void
    onBack: () => void
}

const HintsSection: React.FC<Props> = (props) => {
    return (
        <div className="hint-section">
            <div className="hint-section__icon">
                <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" onClick={() => props.onBack()} color="#133371" />
            </div>

            <span className="hint-section__title">{props.topic.title}</span>
            <div className="hint-section__items">
                {props.hints !== null &&
                    props.hints.map((hint, index) => (
                        <HintBubble
                            key={hint.title}
                            item={hint}
                            index={index}
                            type={HintItemType.hint}
                            onSelect={(hint) => {
                                props.onSelect(hint as Hint)
                            }}
                        />
                    ))}
            </div>
        </div>
    )
}

export default HintsSection
